module.exports = __webpack_public_path__ + "img/share_txt_fx.f99a5471.png";